import { Component, Input, OnInit, inject } from '@angular/core';
import {ActivityInterface} from '../../../../class/api/Activity';
import {AuthentificationService} from '../../../../core/services/authentification.service';
import { DatePipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { LogCommentBoxComponent } from '../log-comment-box/log-comment-box.component';

@Component({
    selector: 'app-log-comments-list',
    templateUrl: './log-comments-list.component.html',
    styleUrls: ['./log-comments-list.component.scss'],
    imports: [MatIcon, LogCommentBoxComponent, DatePipe]
})
export class LogCommentsListComponent implements OnInit {
    private authService = inject(AuthentificationService);


    @Input() public activity: ActivityInterface;
    @Input() public showCommentBox = false;
    @Input() public hideCommentBox = false;


    public isAdmin = false;

    constructor() {
        this.isAdmin = this.authService.isAdmin();
    }

    ngOnInit(): void {
    }

    public editComment(comment) {
        comment['editing'] = true;
    }
}
